export function calculateResults(answers) {
    return answers.reduce((total, answer) => total + answer, 0);
}

export function getResult(score) {
    if (score <= 14) {
        return {
            title: 'Достаточно отдыха',
            text: 'Вы получаете достаточно отдыха в этой сфере.'
        };
    }

    if (score <= 22) {
        return {
            title: 'Отдыха можно добавить',
            text: 'Вы отдыхаете в этой сфере, но могли бы чувствовать себя лучше, если добавить ещё.'
        };
    }

    if (score <= 31) {
        return {
            title: 'Нехватка отдыха',
            text: 'Вы ощущаете последствия нехватки отдыха — стоит внести изменения.'
        };
    }

    return {
        title: 'Заметная нехватка отдыха',
        text: 'Недостаток отдыха в этой сфере заметно влияет на вашу жизнь.'
    };
}

export function saveResults(key, result) {
    localStorage.setItem(key, JSON.stringify(result));
}